import { useMutation, useQueryClient } from "@tanstack/vue-query";
import Contact from "@/services/contact/contact";
import type { ImportFromHubSpotDto } from "@/dtos/HubSpot.dto";

/**
 * Composable for importing contacts via CSV file
 */
export function useImportContact() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (formData: FormData) => {
      const result = await Contact.importContact(formData);
      if (!result.data.status) {
        throw new Error(result.data.msg || "Failed to import contacts");
      }
      return result.data.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["contacts"] });
      queryClient.invalidateQueries({ queryKey: ["bucketCounts"] });
    },
  });
}

/**
 * Composable for importing contacts from HubSpot lists
 */
export function useImportFromHubSpot() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: ImportFromHubSpotDto) => {
      const result = await Contact.importFromHubSpot(data);
      if (!result.data.status) {
        throw new Error(result.data.msg || "Failed to import contacts from HubSpot");
      }
      return result.data.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["contacts"] });
      queryClient.invalidateQueries({ queryKey: ["bucketCounts"] });
    },
  });
}
